import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[minmax(0,1fr)_46%]">
      <div className="flex flex-col justify-between px-7 py-12 sm:px-16 lg:px-20">
        <div>
          <div className="font-serif text-2xl tracking-tight text-ink">
            Ästhetik<span className="text-lime">.</span>
          </div>
          <div className="overline mt-2">Design Co · Operating System</div>
        </div>

        <div className="max-w-md py-16">
          <h1 className="font-serif text-4xl tracking-tight text-ink sm:text-5xl">Welcome back.</h1>
          <p className="mt-4 text-sm leading-relaxed text-stone">
            Sign in to your studio workspace — projects, sourcing, procurement and budgets in one place.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
            <label className="block">
              <span className="overline mb-2 block">Email</span>
              <input
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-sm border border-line bg-white px-4 py-3 text-sm outline-none transition-colors focus:border-lime"
              />
            </label>
            <label className="block">
              <span className="overline mb-2 block">Password</span>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-sm border border-line bg-white px-4 py-3 text-sm outline-none transition-colors focus:border-lime"
              />
            </label>
            {error && (
              <div data-testid="login-error" className="rounded-sm border border-[#E07A5F] bg-[#F6DED6] px-4 py-3 text-sm text-[#A8492E]">
                {error}
              </div>
            )}
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={busy}
              className="w-full rounded-sm bg-lime px-6 py-3 text-sm font-medium text-ink transition-colors hover:bg-lime-dark disabled:opacity-60"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="mt-10 border-t border-line pt-6 text-xs leading-relaxed text-fog">
            Signing in from <span className="text-stone">asthetik.design/admin</span> brings you
            straight here — no second password needed.
          </div>
        </div>
        <div className="text-xs text-fog">© {new Date().getFullYear()} Ästhetik Design Co.</div>
      </div>

      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt="Interior design"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/20" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="font-serif text-2xl leading-snug text-white">
            “Specify with intention. Track every detail.”
          </p>
        </div>
      </div>
    </div>
  );
}
